import { useEffect, useRef, useState, useCallback, useLayoutEffect } from "react";

import axios from "axios";
import ReactQuill from "react-quill";
import Form from "react-bootstrap/Form";

import BackImg from "../../../assets/images/Back.png";
import DollarIcon from "../../../assets/images/dollar-icon.svg";

import "./index.css";
import { DEV_API, Logo } from "../../../const";
import CustomModal from "../../Modal/modal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { parseBoolean } from "../../../func";

import Quarter from "../../Quarter/Quarter";
import Quarter2 from "../../Quarter/Quarter_2";

import { NHL_NEW, NFL2, MLB_NEW, NCAAFB2, NBA_NEW, NCAABB_NEW } from "./imageData";
import { useSlide } from "../SlideContext";

// NHL_NEW dataset names that correspond to images (module scope to avoid hook deps)
const NHL_NEW_DATASET_NAMES = ["P1", "P2", "SOG2", "GOAL1", "FO1", "SOG1"];
const NFL2_DATASET_NAMES = ["1st", "PEN2", "SACK", "TD", "FGMS2", "FGMS1", "TO2", "PTO2", "KOTO1", "PUNT2", "SAFETY", "PASS", "RUN", "FG", "FG+", "TFL"];
const MLB_NEW_DATASET_NAMES = ["HR1", "FCER1", "E1", "HBP1", "SINGLE1", "WALK1", "RBI1", "RBI2", "STEAL1", "KL2", "KS2", "OUTK2", "DBPL2", "TRIPLE1", "DOUBLE1"];
const NCAAFB2_DATASET_NAMES = ["PEN", "1ST", "SACK1", "TD1", "FGMS2", "FGMS1", "TO2", "PTO2", "KOTO2", "PUNT2", "SAFETY", "PASS", "RUN", "FG1", "FG+", "TFL"];
const NBA_NEW_DATASET_NAMES = ["FTMK1", "FTMK2", "3PT1", "3PT2", "FTMS1", "FTMS2", "DUNK1", "FL2", "FOUL1", "OFL2", "BLK1"];
const NCAABB_NEW_DATASET_NAMES = ["FTMK2", "3MK2", "FTMS1", "FTMS2", "DUNK1", "FL2", "BLK1"];
// const SOCCER_NEW_DATASET_NAMES = ["P1", "P2", "GOAL1", "CORNER", "FOUL", "SAVE"];

const teamList = [0, 1, 2, 3];
const MLB_TEAM_LIST = [0, 1, 2]; // MLB_NEW only has 3 teams
const SOCCER_TEAM_LIST = [0, 1]; // SOCCER_NEW only has 2 teams
const TEAM_COLOR = ["red", "blue", "green", "yellow"];

function PlayComponent(props) {
  const {
    // tabStatus,
    eventId,
    team1Idx,
    playList,
    awayScore,
    homeScore,
    time,
    tableScore,
    selTblIdx,

    sportCategory,
    closetScorePair,
    playerNames,
    player1Name,
    player2Name,
    player3Name,
    player4Name,

    handlePlayName,
    winProbability,
    primaryColor,
    secondaryColor,
    startPos,
    DSList,
    editPrimaryTeam,
    isLoading,
    isFree,
    payout,
    point,
    resultList,
  } = props;

  const navigate = useNavigate();
  const inputRef = useRef(null);

  const { user, isDemo } = useSelector((state) => state.auth);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [scoringRulesModelIsOpen, setScoringRulesModelIsOpen] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);
  const [teamIdxModal, setTeamIdxModal] = useState(-1);
  const [scoringRules, setScoringRules] = useState([]);
  const [selectedSport, setSelectedSport] = useState(-1);
  const [primaryTeamIdx, setPrimaryTeamIdx] = useState(parseInt(startPos));
  const [copied, setCopied] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [slideImage, setSlideImage] = useState(null);
  const [showSlide, setShowSlide] = useState(false);
  const bigPlateRef = useRef(null);
  const [anchorRect, setAnchorRect] = useState(null);
  const lastProcessedItemRef = useRef(null);
  // MLB_NEW slide rotation helpers
  const rotationTimeoutsRef = useRef([]);
  const isRotatingRef = useRef(false);

  // Slide context for slide persistence across refreshes
  const slide = useSlide();

  // Normalize Google Drive link to embeddable view URL
  const toDriveViewUrl = useCallback((url) => {
    if (!url) return url;
    const id = url.match(/id=([a-zA-Z0-9_-]+)/)?.[1] || url.match(/\/d\/([a-zA-Z0-9_-]+)/)?.[1];
    return id ? `https://drive.google.com/uc?export=view&id=${id}` : url;
  }, []);


  // Extract Drive file id from either share or uc link
  const getDriveId = useCallback((url) => {
    if (!url) return null;
    let m = url.match(/id=([a-zA-Z0-9_-]+)/);
    if (m) return m[1];
    m = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    return m ? m[1] : null;
  }, []);

  // Thumbnail endpoint often serves reliably for images
  const toDriveThumbUrl = useCallback((url) => {
    const id = getDriveId(url);
    return id ? `https://drive.google.com/thumbnail?id=${id}&sz=w1000` : url;
  }, [getDriveId]);


  // 

  useEffect(() => {
    if (modalIsOpen) {
      // Add a small delay to ensure the input is rendered before focusing
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [modalIsOpen]);

  useEffect(() => {
    setTeamIdxModal(selTblIdx);
    document.body.style.backgroundColor = secondaryColor;

    // fetch scoring rules data
    axios
      .get(`${DEV_API}/api/sports/getallscoringrules`, {
        // params: {
        //   player: user._id,
        //   win: [1, 2]
        // }
      })
      .then((response) => {
        const fetchedScoringRules = response.data.result || [];
        setScoringRules(fetchedScoringRules);
      });
  }, [secondaryColor, selTblIdx, time]);

  // Effect to check for slide triggers when DSList changes
  useEffect(() => {
    // Use sorted data from getReorderedDSList() instead of original DSList
    const sortedDSList = getReorderedDSList();
    const currentQuarterData = sortedDSList[selTblIdx]; // Get the current quarter's sorted data
    // MLB_NEW: when last 3 datasets contain at least 2 slide events, rotate each for 5s
    if (currentQuarterData && currentQuarterData.length > 0) {
      // Do not run during/after game end
      if (time && (time.includes('FINAL') || time.includes('END') || time === '0:00' || time === '0:00:00')) {
        return;
      }

      // Get the 3 most recent items by wallclock time
      const lastThree = currentQuarterData.slice().sort((a, b) => {
        const dateA = new Date(a.wallclock || 0);
        const dateB = new Date(b.wallclock || 0);
        return dateB - dateA;
      }).slice(0, 3);
      const imgs = [];
      for (let item of lastThree) {
        const ds = item?.no?.split("-")?.[1];
        if (ds && MLB_NEW_DATASET_NAMES.includes(ds)) {
          const rawUrl = MLB_NEW[ds];
          if (rawUrl) {
            imgs.push(toDriveViewUrl(rawUrl));
          }
        }
      }

      if (imgs.length >= 1) {
        // clear any existing timers
        rotationTimeoutsRef.current.forEach(clearTimeout);
        rotationTimeoutsRef.current = [];
        isRotatingRef.current = true;

        // Ensure anchorRect is measured before showing slide
        if (!anchorRect && bigPlateRef.current) {
          const rect = bigPlateRef.current.getBoundingClientRect();
          setAnchorRect({ left: rect.left, top: rect.top, width: rect.width, height: rect.height });
        }

        setShowSlide(true);
        setSlideImage(imgs[0]);
        // persist via context with dataset ID to prevent repeats
        const datasetId = lastThree.map(item => item.no).join('|');
        slide.show(imgs[0], imgs.length >= 2 ? imgs.length * 5000 : 12000, datasetId);

        if (imgs.length >= 2) {
          // Multiple images: rotate every 5 seconds
          for (let i = 1; i < imgs.length; i++) {
            const t = setTimeout(() => {
              setSlideImage(imgs[i]);
            }, i * 5000);
            rotationTimeoutsRef.current.push(t);
          }

          // hide after finishing rotation
          const endT = setTimeout(() => {
            setShowSlide(false);
            setTimeout(() => {
              setSlideImage(null);
            }, 300);
            isRotatingRef.current = false;
          }, imgs.length * 5000);
          rotationTimeoutsRef.current.push(endT);
        } else {
          // Single image: show for 10 seconds (like other sports)
          const endT = setTimeout(() => {
            setShowSlide(false);
            setTimeout(() => {
              setSlideImage(null);
            }, 300);
            isRotatingRef.current = false;
          }, 12000);
          rotationTimeoutsRef.current.push(endT);
        }

        // cleanup on next run/unmount
        return () => {
          rotationTimeoutsRef.current.forEach(clearTimeout);
          rotationTimeoutsRef.current = [];
          isRotatingRef.current = false;
        };
      }
    }
    if (currentQuarterData && currentQuarterData.length > 0) {
      // Skip single-image flow while rotating MLB slides
      if (isRotatingRef.current) return;
      // Check if game has ended - don't show slide images after game ends
      if (time && (time.includes('FINAL') || time.includes('END') || time === '0:00' || time === '0:00:00')) {
        return;
      }
      
      // Get the most recent item by wallclock time
      const mostRecentItem = currentQuarterData.reduce((latest, current) => {
        const latestTime = new Date(latest.wallclock || 0);
        const currentTime = new Date(current.wallclock || 0);
        return currentTime > latestTime ? current : latest;
      });
      
      let datasetNames;
      switch (sportCategory) {
        case "NHL_NEW":
          datasetNames = NHL_NEW_DATASET_NAMES;
          break;
        case "MLB_NEW":
          datasetNames = MLB_NEW_DATASET_NAMES;
          break;
        case "NCAAFB2":
          datasetNames = NCAAFB2_DATASET_NAMES;
          break;
        case "NBA_NEW":
          datasetNames = NBA_NEW_DATASET_NAMES;
          break;
        case "NCAABB_NEW":
          datasetNames = NCAABB_NEW_DATASET_NAMES;
          break;
          // case "SOCCER_NEW":
          //   datasetNames = SOCCER_NEW_DATASET_NAMES;
          //   break;
        default:
          datasetNames = NFL2_DATASET_NAMES;
          break;
      }
      
      // Find most recent item that requires slide image
      let mostRecentSlideItem = null;
      
      if (sportCategory === "NHL_NEW" || sportCategory === "MLB_NEW" || sportCategory === "NCAABB_NEW"
        || sportCategory === "NBA_NEW" || sportCategory === "NCAAFB2" || sportCategory === "NFL2"

      ) {
        // For NHL_NEW and MLB_NEW, only check most recent 2 datasets
        if (currentQuarterData.length >= 2) {
          // Find the second most recent item by wallclock time (consistent with mostRecentItem logic)
          const sortedByTime = currentQuarterData.slice().sort((a, b) => {
            const dateA = new Date(a.wallclock || 0);
            const dateB = new Date(b.wallclock || 0);
            return dateB - dateA; // Most recent first
          });
          const previousItem = sortedByTime[1]; // Second most recent
          
          // Check if they have the same seq number
          const mostRecentSeq = mostRecentItem.seq || mostRecentItem.no.split("-")[0];
          const previousSeq = previousItem.seq || previousItem.no.split("-")[0];
          
          if (Number(mostRecentSeq) === Number(previousSeq)) {
            // Both items have same seq, find which one requires slide image
            for (let ds of datasetNames) {
              if (mostRecentItem.no.split("-")[1]?.includes(ds)) {
                mostRecentSlideItem = mostRecentItem;
                break;
              }
              if (previousItem.no.split("-")[1]?.includes(ds)) {
                mostRecentSlideItem = previousItem;
                break;
              }
            }
          } else {
            // Different seq numbers, only check the most recent dataset
            for (let ds of datasetNames) {
              if (mostRecentItem.no.split("-")[1]?.includes(ds)) {
                mostRecentSlideItem = mostRecentItem;
                break;
              }
            }
          }
        } else {
          // Only one dataset, check if it requires slide image
          for (let ds of datasetNames) {
            if (mostRecentItem.no.split("-")[1]?.includes(ds)) {
              mostRecentSlideItem = mostRecentItem;
              break;
            }
          }
        }
      } else {
        // For other sports, use standard logic
        for (let i = currentQuarterData.length - 1; i >= 0; i--) {
          const item = currentQuarterData[i];
          for(let ds of datasetNames) {
            if(item.no.split("-")[1]?.includes(ds)) {
              mostRecentSlideItem = item;
              break;
            }
          }
          if (mostRecentSlideItem) break;
        }
      }
      
      // Only process if we found a slide item
      if (!mostRecentSlideItem) {
        
        // Check if there's a previous slide that should still be displayed
        if (slide.isVisible && slide.imageUrl && Date.now() < slide.expiresAt) {
          setShowSlide(true);
          setSlideImage(slide.imageUrl);
        }
        return;
      }
      
      // Check if this is a new slide item (different from last processed)
      const isNewSlideItem = lastProcessedItemRef.current !== mostRecentSlideItem.no;
      
      
      // If it's not a new slide item, don't show the slide again
      if (!isNewSlideItem) {
        return;
      }
      
      // Update the last processed item
      lastProcessedItemRef.current = mostRecentSlideItem.no;
      for(let ds of datasetNames) {
        if(mostRecentSlideItem.no.split("-")[1]?.includes(ds)) {
          // Ensure anchorRect is measured before showing slide
          if (!anchorRect && bigPlateRef.current) {
            const rect = bigPlateRef.current.getBoundingClientRect();
            setAnchorRect({ left: rect.left, top: rect.top, width: rect.width, height: rect.height });
          }
          
          // For NHL_NEW, use a more stable vertical position
          if (sportCategory === "NHL_NEW" && anchorRect) {
            // Lock the vertical position to prevent jumping
            const stableTop = anchorRect.top + (anchorRect.height / 2);
            setAnchorRect(prev => ({ ...prev, top: stableTop }));
          }
          let rawUrl;
          switch (sportCategory) {
            case "NHL_NEW":
              rawUrl = NHL_NEW[ds];
              break;
            case "MLB_NEW":
              rawUrl = MLB_NEW[ds];
              break;
            case "NCAAFB2":
              rawUrl = NCAAFB2[ds];
              break;
            case "NBA_NEW":
              rawUrl = NBA_NEW[ds];
              break;
            case "NCAABB_NEW":
              rawUrl = NCAABB_NEW[ds];
              break;
            // case "SOCCER_NEW":
            //   rawUrl = SOCCER_NEW[ds];
            //   break;
            default:
              rawUrl = NFL2[ds];
              break;
          }
          const viewUrl = toDriveViewUrl(rawUrl);
          console.log(rawUrl, "rawUrl");
          // Show slide immediately with dataset ID to prevent repeats
          setSlideImage(viewUrl);
          setShowSlide(true);
          slide.show(viewUrl, 12000, mostRecentSlideItem.no);
          break;
        }
      }
    }
  }, [DSList, selTblIdx, sportCategory, slide, toDriveViewUrl, anchorRect, time, showSlide]);

  // Separate effect to handle context-based slide persistence
  useEffect(() => {
    if (slide?.isVisible && slide?.imageUrl && Date.now() < slide.expiresAt) {
      setShowSlide(true);
      setSlideImage(slide.imageUrl);
    } else if (slide?.isVisible === false) {
      setShowSlide(false);
      setSlideImage(null);
    }
  }, [slide?.isVisible, slide?.imageUrl, slide?.expiresAt]);

  // Handle window resize for responsive Quarter components
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (bigPlateRef.current) {
        const rect = bigPlateRef.current.getBoundingClientRect();
        setAnchorRect({ left: rect.left, top: rect.top, width: rect.width, height: rect.height });
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Measure biggest plate position when layout/data changes (before paint to avoid jump)
  useLayoutEffect(() => {
    if (bigPlateRef.current && !showSlide) {
      const rect = bigPlateRef.current.getBoundingClientRect();
      setAnchorRect({ left: rect.left, top: rect.top, width: rect.width, height: rect.height });
    }
  }, [windowWidth, sportCategory, selTblIdx, tableScore, showSlide]);

  const saveFavourite = async () => {
    const response = await axios.post(`${DEV_API}/api/favourites`, {
      player: user._id,
      event: eventId,
      teams: playList.boxscore.teams,
      sportCategory,
      startPos: startPos,
      entryPoint: 0,
      winPoint: 0,
      selectedTeam: team1Idx,
      player1Name,
      player2Name,
      player3Name,
      player4Name,
    });
    if (response.data.success) {
      toast("Game saved!");
    }
  };

  const handleEditPlayerName = (index) => {
    if (team1Idx !== -1) {
      setModalIsOpen(true);
    }
    setTeamIdxModal(index);
  };

  const handleClckScoringRules = () => {
    if (scoringRules.length > 0) setSelectedSport(0);
    setScoringRulesModelIsOpen(true);
  };

  const goBack = () => {
    navigate("/register");
  };

  const backgroundUrl =
    team1Idx !== -1 && playList?.boxscore?.teams[team1Idx]?.team?.logo;
  const commonBackground = `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${backgroundUrl}) bottom left / 50% no-repeat`;

  const USER_POS = sportCategory === "MLB_NEW" ? (3 - startPos) % 3 : (4 - startPos) % 4;

  // Function to reorder DSList based on current quarter
  const getReorderedDSList = () => {
    // if(sportCategory === "MLB_NEW") {
    //   if (!DSList || DSList.length === 0) return [];

    //   // For MLB_NEW, reorder by period (9-1) in reverse order while maintaining team grouping
    //   // DSList is resultList: [team1Array, team2Array, team3Array]
    //   // Each team array contains datasets with period property
    //   const periodOrder = [9, 8, 7, 6, 5, 4, 3, 2, 1];
    //   const reorderedDSList = [];
    //   // Group datasets by period across all teams
    //   periodOrder.forEach(period => {
    //     DSList.forEach((teamArray, teamIndex) => {
    //       if (teamArray && teamArray.length > 0) {
    //         // Filter datasets for this period from this team
    //         const periodDatasets = teamArray.filter(item => {
    //           // First check if period matches exactly
    //           if (item.period === period) {
    //             return true;
    //           }
    //           // For periods 1-2, also include datasets that don't have period set
    //           // but are in the correct team array based on the period-team mapping
    //           if ((period === 1 || period === 2) && (item.period === undefined || item.period === null)) {
    //             // Period 1 should be in teamArray[0], Period 2 should be in teamArray[1]
    //             const expectedTeamIndex = period === 1 ? 0 : 1;
    //             return teamIndex === expectedTeamIndex;
    //           }
    //           return false;
    //         });
    //         if (periodDatasets.length > 0) {
    //           reorderedDSList.push(periodDatasets);
    //         }
    //       }
    //     });
    //   });

    //   return reorderedDSList;
    // } 
    if(sportCategory === "NHL_NEW") {
      if (!DSList || DSList.length === 0) return [];

      const currentQuarter = selTblIdx; // Current quarter (0-3)
      const reorderedIndices = [];

      for (let i = 0; i < 3; i++) {
        const quarterIndex = (currentQuarter - i + 3) % 3;
        reorderedIndices.push(quarterIndex);
      }

      // Collect all events from all teams and sort globally by wallclock
      const allEvents = [];
      reorderedIndices.forEach((index) => {
        const teamArray = DSList[index] || [];
        teamArray.forEach((item, itemIndex) => {
          allEvents.push({
            ...item,
            originalTeamIndex: index,
            originalItemIndex: itemIndex
          });
        });
      });
      
      // Sort all events globally by wallclock (oldest first - chronological order)
      allEvents.sort((a, b) => {
        const dateA = new Date(a.wallclock || 0);
        const dateB = new Date(b.wallclock || 0);
        const result = dateA - dateB; // Oldest first (chronological order)
                
        return result;
      });
      
      // Group back by team while preserving global chronological order
      const result = reorderedIndices.map((index) => {
        const teamEvents = allEvents.filter(item => item.originalTeamIndex === index);
        return teamEvents;
      });
      
      return result;
    } else if(sportCategory === "SOCCER_NEW") {
      if (!DSList || DSList.length === 0) return [];

      const currentQuarter = selTblIdx; // Current quarter (0-1)
      const reorderedIndices = [];

      for (let i = 0; i < 2; i++) {
        const quarterIndex = (currentQuarter - i + 2) % 2;
        reorderedIndices.push(quarterIndex);
      }

      // Return DSList items in the new order
      return reorderedIndices.map((index) => DSList[index] || []);
    } else {
    if (!DSList || DSList.length === 0) return [];

    const currentQuarter = selTblIdx; // Current quarter (0-3)
    const reorderedIndices = [];
    
    if(sportCategory === "MLB_NEW") {
      for (let i = 0; i < 3; i++) {
        const quarterIndex = (currentQuarter - i + 3) % 3;
        reorderedIndices.push(quarterIndex);
      }
    } else {
      for (let i = 0; i < 4; i++) {
        const quarterIndex = (currentQuarter - i + 4) % 4;
        reorderedIndices.push(quarterIndex);
      }
    }

    // Return DSList items in the new order
    return reorderedIndices.map((index) => DSList[index] || []);
    }
    
  };

  // Calculate responsive dimensions based on display width
  const getResponsiveDimensions = (isLarge) => {
    const baseWidth = isLarge ? 360 : 112;
    const baseHeight = isLarge ? 139 : 75;
    const scaleFactor = Math.min(1, windowWidth / 430);
    return {
      width: `${Math.min(baseWidth, baseWidth * scaleFactor)}px`,
      height: `${Math.min(baseHeight, baseHeight * scaleFactor)}px`,
    };
  };

  // Calculate responsive gap based on display width
  const getResponsiveGap = () => {
    const baseGap = 12; // Original gap at 430px
    const scaleFactor = Math.min(1, windowWidth / 430);
    return `${Math.min(baseGap, baseGap * scaleFactor)}px`;
  };

  // Calculate responsive max-width based on display width
  const getResponsiveMaxWidth = () => {
    const baseMaxWidth = 360; // Original max-width at 430px
    const scaleFactor = Math.min(1, windowWidth / 430);
    return `${Math.min(baseMaxWidth, baseMaxWidth * scaleFactor)}px`;
  };

  // Reorder indices based on DSList[idx] existence with specific priority
  const getReorderedIndices = () => {
    if (sportCategory === "MLB_NEW") {
      // For MLB_NEW, prioritize current period (selTblIdx) in the largest plate
      const indices = [0, 1, 2];
      const currentPeriod = selTblIdx % 3; // Ensure it's within 0-2 range
      
      // Check if DSList[idx] exists and has content for each Quarter component
      const withResults = indices.filter(
        (idx) => DSList && DSList[idx] && DSList[idx].length > 0
      );
      const withoutResults = indices.filter(
        (idx) => !DSList || !DSList[idx] || DSList[idx].length === 0
      );

      // If no DSList entries exist, put current period in largest plate
      if (withResults.length === 0) {
        const otherIndices = indices.filter(idx => idx !== currentPeriod);
        return [otherIndices[0], otherIndices[1], currentPeriod];
      }

      // When DSList exists: put current period in largest plate (position 2)
      const reordered = [];
      const otherIndices = indices.filter(idx => idx !== currentPeriod);
      
      // Fill positions 0,1 with other indices
      reordered[0] = otherIndices[0];
      reordered[1] = otherIndices[1];
      // Put current period in largest plate (position 2)
      reordered[2] = currentPeriod;

      return reordered;
    } else if (sportCategory === "NHL_NEW") {
      const indices = [0, 1, 2];
      // Check if DSList[idx] exists and has content for each Quarter component
        const withResults = indices.filter(
          (idx) => DSList && DSList[idx] && DSList[idx].length > 0
        );
        const withoutResults = indices.filter(
          (idx) => !DSList || !DSList[idx] || DSList[idx].length === 0
        );

        // If no DSList entries exist, use specific arrangement [1, 2, 0]
        if (withResults.length === 0) {
          return [1, 2, 0];
        }

        // When DSList exists: specific ordering based on scenarios
        const reordered = [];

        // Sort withResults in ascending order (lowest idx first)
        const sortedWithResults = withResults.sort((a, b) => a - b);

        // Sort withoutResults in ascending order (lowest idx first)
        const sortedWithoutResults = withoutResults.sort((a, b) => a - b);

        // Special case: All have results - positions 0,1,2 (ascending order)
        if (withResults.length === 3) {
          return [0, 1, 2];
        }

        // Normal case: withoutResults fill positions 0,1,2; withResults fill remaining positions
        // Fill positions 0,1 with withoutResults (ascending)
        for (let i = 0; i < 2; i++) {
          if (i < sortedWithoutResults.length) {
            reordered[i] = sortedWithoutResults[i];
          }
        }

        // Fill remaining positions (starting from 2) with withResults (ascending)
        for (let i = 0; i < sortedWithResults.length; i++) {
          reordered[i + sortedWithoutResults.length] = sortedWithResults[i];
        }

        return reordered;
      
    } else if (sportCategory === "SOCCER_NEW") {
      const indices = [0, 1];
      const currentPeriod = selTblIdx % 2; // Ensure it's within 0-1 range
      
      // Check if DSList[idx] exists and has content for each Quarter component
      const withResults = indices.filter(
        (idx) => DSList && DSList[idx] && DSList[idx].length > 0
      );
      const withoutResults = indices.filter(
        (idx) => !DSList || !DSList[idx] || DSList[idx].length === 0
      );

      // If no DSList entries exist, put current period in largest plate
      if (withResults.length === 0) {
        const otherIndices = indices.filter(idx => idx !== currentPeriod);
        return [otherIndices[0], currentPeriod];
      }

      // When DSList exists: put current period in largest plate (position 1)
      const reordered = [];
      const otherIndices = indices.filter(idx => idx !== currentPeriod);
      
      // Fill position 0 with other index
      reordered[0] = otherIndices[0];
      // Put current period in largest plate (position 1)
      reordered[1] = currentPeriod;

      return reordered;
    } else {
      const indices = [0, 1, 2, 3];

      // For NFL2, NCAAFB2, and MLB_NEW, use the original logic with 3+1 layout
      if (sportCategory === "NFL2" || sportCategory === "NCAAFB2" || sportCategory === "NBA_NEW" || sportCategory === "NCAABB_NEW") {
        // Check if DSList[idx] exists and has content for each Quarter component
        const withResults = indices.filter(
          (idx) => DSList && DSList[idx] && DSList[idx].length > 0
        );
        const withoutResults = indices.filter(
          (idx) => !DSList || !DSList[idx] || DSList[idx].length === 0
        );

        // If no DSList entries exist, use specific arrangement [1, 2, 3, 0]
        if (withResults.length === 0) {
          return [1, 2, 3, 0];
        }

        // When DSList exists: specific ordering based on scenarios
        const reordered = [];

        // Sort withResults in ascending order (lowest idx first)
        const sortedWithResults = withResults.sort((a, b) => a - b);

        // Sort withoutResults in ascending order (lowest idx first)
        const sortedWithoutResults = withoutResults.sort((a, b) => a - b);

        // Special case: All have results - positions 0,1,2,3 (ascending order)
        if (withResults.length === 4) {
          return [0, 1, 2, 3];
        }

        // Normal case: withoutResults fill positions 0,1,2; withResults fill remaining positions
        // Fill positions 0,1,2 with withoutResults (ascending)
        for (let i = 0; i < 3; i++) {
          if (i < sortedWithoutResults.length) {
            reordered[i] = sortedWithoutResults[i];
          }
        }

        // Fill remaining positions (starting from 3) with withResults (ascending)
        for (let i = 0; i < sortedWithResults.length; i++) {
          reordered[i + sortedWithoutResults.length] = sortedWithResults[i];
        }

        return reordered;
      } else {
        // For all other cases, return all 4 indices in order for horizontal display
        return [0, 1, 2, 3];
      }
    }
  };

  const get_NHL_NEW_Time = (time) => {
    const interval = 1200 - time.split(":")[0] * 60 - time.split(":")[1];
    return `${Math.floor(interval / 60)}:${interval % 60 < 10 ? "0" + (interval % 60) : interval % 60}`;
  };

  


  return (
    <>
      <div className="main" style={{ maxWidth: 430, margin: "0 auto" }}>
        <div className="wrapper">
          <div className="full-width">
            <div
              className="header"
              style={{
                backgroundColor: primaryColor,
                color: secondaryColor,
                position: "relative",
              }}
            >
              <div className="header-left">
                {isDemo ? (
                  <button onClick={goBack} style={{ background: 'none', border: 'none', padding: 0 }}>
                    <img src={BackImg} alt="Back" />
                  </button>
                ) : (
                  <>
                    <span
                      onClick={() => handleClckScoringRules()}
                      style={{
                        color: secondaryColor,
                        borderColor: secondaryColor,
                        marginTop: -7,
                      }}
                    >
                      Rules
                    </span>
                    <span
                      onClick={() => setInviteModal(true)}
                      style={{
                        color: secondaryColor,
                        borderColor: secondaryColor,
                        marginTop: 14,
                      }}
                    >
                      Invite
                    </span>
                  </>
                )}
              </div>
              <div className="header-center">
                <a href="/">
                  <h1
                    className="text-center text-uppercase"
                    style={{ color: secondaryColor }}
                  >
                    BallHog
                  </h1>
                </a>
              </div>
              <div className="header-right">
                {isDemo ? (
                  <>
                    <>
                      <span
                        onClick={() => handleClckScoringRules()}
                        style={{
                          color: secondaryColor,
                          borderColor: secondaryColor,
                          marginTop: -7,
                        }}
                      >
                        Rules
                      </span>
                      <br />
                      <span
                        onClick={() => setInviteModal(true)}
                        style={{
                          color: secondaryColor,
                          borderColor: secondaryColor,
                          marginTop: 14,
                        }}
                      >
                        Invite
                      </span>
                    </>
                  </>
                ) : (
                  <>
                    {parseBoolean(isFree) ? (
                      <span
                        onClick={() => saveFavourite()}
                        style={{
                          display: "inline-block",
                          color: secondaryColor,
                          borderColor: secondaryColor,
                          marginTop: 11,
                        }}
                      >
                        Save
                      </span>
                    ) : (
                      <div className="d-inline-block">
                        <img
                          src={DollarIcon}
                          alt="Dollar icon"
                          onClick={() => {
                            navigate("/activeGames");
                          }}
                          style={{
                            paddingRight: 15,
                            width: 35,
                            height: 35,
                            marginTop: -10,
                            marginRight: -15,
                          }}
                        />
                        <p className="d-inline-block text-white h3 mt-2">
                          {point}
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div
              className="fixed-background"
              style={{
                position: "fixed",
                bottom: 0,
                marginLeft: 20,
                margin: "0 auto",
                maxWidth: 350,
                width: "100%",
                height: "50%",
                background: commonBackground,
                zIndex: 1, // Ensures it is behind the content
              }}
            ></div>
            <div className="app-body">
              <div className="app-team">
                <div className="team-score">
                  <div className="score-left">
                    <span>
                      <img
                        src={
                          team1Idx !== -1 && playList.boxscore
                            ? playList.boxscore.teams[team1Idx].team.logo
                            : Logo[sportCategory]
                        }
                        alt="Team logo"
                      />
                    </span>
                    <p>
                      {(() => {
                        // Prefer derived values for SOCCER_NEW when applicable
                        let leftScore = team1Idx !== -1 && playList.boxscore && team1Idx === 0 ? awayScore : homeScore;
                        if (sportCategory === "SOCCER_NEW") {
                          try {
                            const competitors = playList?.header?.competitions?.[0]?.competitors || [];
                            const home = competitors.find((t) => t.homeAway === "home");
                            const away = competitors.find((t) => t.homeAway === "away");
                            const parsedHome = home && (parseInt(home.score, 10) || 0);
                            const parsedAway = away && (parseInt(away.score, 10) || 0);
                            const preferDerived = (homeScore == null || awayScore == null) || (homeScore === 0 && awayScore === 0) || (!Number.isFinite(leftScore));
                            if (preferDerived) {
                              leftScore = team1Idx === 0 ? parsedAway : parsedHome;
                            }
                          } catch (e) {}
                        }
                        return leftScore;
                      })()}
                    </p>
                  </div>
                  <div className="score-center">
                    <small>{time}</small>
                    <p className="text-white">
                      {team1Idx === 1
                        ? winProbability?.homeWinPercentage != null
                          ? `${
                              playList.boxscore.teams[team1Idx].team
                                .shortDisplayName
                            } win ${(
                              winProbability.homeWinPercentage * 100
                            ).toFixed(2)}%`
                          : ""
                        : winProbability?.homeWinPercentage != null
                        ? `${
                            playList.boxscore.teams[team1Idx].team
                              .shortDisplayName
                          } win ${(
                            (1 - winProbability.homeWinPercentage) *
                            100
                          ).toFixed(2)}%`
                        : ""}
                    </p>
                  </div>
                  <div className="score-right">
                    <p>
                      {(() => {
                        let rightScore = team1Idx !== -1 && team1Idx === 0 ? homeScore : awayScore;
                        if (sportCategory === "SOCCER_NEW") {
                          try {
                            const competitors = playList?.header?.competitions?.[0]?.competitors || [];
                            const home = competitors.find((t) => t.homeAway === "home");
                            const away = competitors.find((t) => t.homeAway === "away");
                            const parsedHome = home && (parseInt(home.score, 10) || 0);
                            const parsedAway = away && (parseInt(away.score, 10) || 0);
                            const preferDerived = (homeScore == null || awayScore == null) || (homeScore === 0 && awayScore === 0) || (!Number.isFinite(rightScore));
                            if (preferDerived) {
                              rightScore = team1Idx === 0 ? parsedHome : parsedAway;
                            }
                          } catch (e) {}
                        }
                        return rightScore;
                      })()}
                    </p>
                    <span>
                      <img
                        src={
                          team1Idx !== -1 && playList.boxscore
                            ? playList.boxscore.teams[
                                (parseInt(team1Idx) + 1) % 2
                              ].team.logo
                            : Logo[sportCategory]
                        }
                        alt="Team logo"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="team-list">
                {sportCategory === "SOCCER_NEW" ? (
                  // SOCCER_NEW: two equal plates like small MLB_NEW tiles
                  <div className="quarter-2-pair-wrapper">
                    {[0, 1].map((idx) => (
                      <div key={`soc-${idx}`}>
                        <Quarter2
                          value={`${tableScore[idx]}`}
                          quarter={{ 0: "P1", 1: "P2" }[idx]}
                          width={getResponsiveDimensions(false).width}
                          height={getResponsiveDimensions(false).height}
                          isLarge={false}
                          color={primaryColor}
                          onClick={() => {
                            if (editPrimaryTeam) {
                              // no-op; consistent with others
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ) : sportCategory === "MLB_NEW" || sportCategory === "NHL_NEW" ? (
                  // MLB_NEW uses Quarter_2 component with 2+1 layout
                  <div className="quarter-2-wrapper">
                    {getReorderedIndices().map((idx, displayIdx) => {
                      return <div key={`q2-${idx}`} ref={displayIdx === 2 ? bigPlateRef : null}>
                      <Quarter2
                      value={`${tableScore[idx]}`}
                      quarter={
                        sportCategory === "MLB_NEW" || sportCategory === "NHL_NEW"
                          ? {
                              0: "P1",
                              1: "P2",
                              2: "P3",
                            }[idx]
                          : {
                              0: player1Name,
                              1: player2Name,
                              2: player3Name,
                            }[idx]
                      }
                      width={
                        getResponsiveDimensions(displayIdx === 2)
                          .width
                      }
                      height={
                        getResponsiveDimensions(displayIdx === 2)
                          .height
                      }
                      isLarge={displayIdx === 2}
                      color={primaryColor}
                      onClick={() => {
                        if (editPrimaryTeam) {
                          // Handle click for editing player names if needed
                        }
                      }}
                    />
                    </div>
                    })}
                  </div>
                ) : (
                  <div
                    className={`${
                      sportCategory === "NFL2" || sportCategory === "NCAAFB2" || sportCategory === "NBA_NEW" || sportCategory === "NCAABB_NEW"
                        ? "nfl-ncaa"
                        : "normal"
                    }`}
                    style={{
                      ...(sportCategory === "NFL2" ||
                      sportCategory === "NCAAFB2" ||
                      sportCategory === "NBA_NEW" ||
                      sportCategory === "NCAABB_NEW"
                        ? {
                            "--responsive-gap": getResponsiveGap(),
                            "--responsive-max-width": getResponsiveMaxWidth(),
                          }
                        : {}),
                    }}
                  >
                    <ul>
                      {getReorderedIndices().map((idx, displayIdx) => {
                        if (parseBoolean(isFree)) {
                          // Free game
                          return (
                            <li key={displayIdx} ref={displayIdx === 3 ? bigPlateRef : null}>
                              {sportCategory === "NFL2" ||
                              sportCategory === "NCAAFB2" ||
                              sportCategory === "NBA_NEW" ||
                              sportCategory === "NCAABB_NEW" ? (
                                <Quarter
                                  color={primaryColor}
                                  value={`${tableScore[idx]}`}
                                  quarter={
                                    sportCategory === "NFL2" ||
                                    sportCategory === "NCAAFB2" ||
                                    sportCategory === "NBA_NEW" ||
                                    sportCategory === "NCAABB_NEW"
                                      ? {
                                          0: "Q1",
                                          1: "Q2",
                                          2: "Q3",
                                          3: "Q4",
                                        }[idx]
                                      : {
                                          0: player1Name,
                                          1: player2Name,
                                          2: player3Name,
                                          3: player4Name,
                                        }[idx]
                                  }
                                  width={
                                    getResponsiveDimensions(displayIdx === 3)
                                      .width
                                  }
                                  height={
                                    getResponsiveDimensions(displayIdx === 3)
                                      .height
                                  }
                                  isLarge={displayIdx === 3}
                                  onClick={() => {
                                    if (editPrimaryTeam)
                                      handleEditPlayerName(idx);
                                  }}
                                ></Quarter>
                              ) : (
                                <>
                                  <span
                                    onClick={() => {
                                      if (editPrimaryTeam)
                                        handleEditPlayerName(idx);
                                    }}
                                    className={`team-${TEAM_COLOR[idx]} ${
                                      idx === selTblIdx
                                        ? " border-white"
                                        : "opacity-50"
                                    }`}
                                  >
                                    {tableScore[idx]}
                                  </span>
                                  <small
                                    onClick={() => {
                                      handleEditPlayerName(idx);
                                    }}
                                  >
                                    {sportCategory === "MLB_NEW" || sportCategory === "NHL_NEW"
                                      ? {
                                          0: "Q1",
                                          1: "Q2",
                                          2: "Q3",
                                        }[idx]
                                      : {
                                          0: player1Name,
                                          1: player2Name,
                                          2: player3Name,
                                          // 3: player4Name,
                                        }[idx]}
                                  </small>
                                </>
                              )}
                            </li>
                          );
                        } else {
                          // Paid Game
                          return (
                            <li key={displayIdx}>
                              {sportCategory === "NFL2" ||
                              sportCategory === "NCAAFB2" ||
                              sportCategory === "NBA_NEW" ||
                              sportCategory === "NCAABB_NEW" ? (
                                <Quarter
                                  value={`${tableScore[idx]}`}
                                  quarter={
                                    sportCategory === "NFL2" ||
                                    sportCategory === "NCAAFB2" ||
                                    sportCategory === "NBA_NEW" ||
                                    sportCategory === "NCAABB_NEW"
                                      ? {
                                          0: "Q1",
                                          1: "Q2",
                                          2: "Q3",
                                          3: "Q4",
                                        }[idx]
                                      : {
                                          0: player1Name,
                                          1: player2Name,
                                          2: player3Name,
                                          3: player4Name,
                                        }[idx]
                                  }
                                  width={
                                    getResponsiveDimensions(displayIdx === 3)
                                      .width
                                  }
                                  height={
                                    getResponsiveDimensions(displayIdx === 3)
                                      .height
                                  }
                                  isLarge={displayIdx === 3}
                                  onClick={() => {
                                    if (editPrimaryTeam)
                                      handleEditPlayerName(idx);
                                  }}
                                ></Quarter>
                              ) : (
                                <>
                                  {parseInt(payout) == 1 ? ( //1v4
                                    <>
                                      <span
                                        className={`team-${TEAM_COLOR[idx]} ${
                                          idx === selTblIdx
                                            ? " border-white"
                                            : "opacity-50"
                                        }`}
                                      >
                                        {tableScore[idx]}
                                      </span>
                                      <small>
                                        {sportCategory === "NFL2" ||
                                        sportCategory === "NCAAFB2" ||
                                        sportCategory === "NBA_NEW" ||
                                        sportCategory === "NCAABB_NEW"
                                          ? {
                                              0: "Q1",
                                              1: "Q2",
                                              2: "Q3",
                                              3: "Q4",
                                            }[idx]
                                          : {
                                              0: player1Name,
                                              1: player2Name,
                                              2: player3Name,
                                              3: player4Name,
                                            }[idx]}
                                      </small>
                                    </>
                                  ) : (
                                    <>
                                      <span // 1v1
                                        className={`team-${TEAM_COLOR[idx]} ${
                                          idx === selTblIdx
                                            ? " border-white"
                                            : "opacity-50"
                                        }`}
                                      >
                                        {closetScorePair.includes(idx)
                                          ? tableScore[idx]
                                          : " "}
                                      </span>
                                      <small>
                                        {
                                          playerNames[idx] || "-"
                                        }
                                      </small>
                                    </>
                                  )}
                                </>
                              )}
                            </li>
                          );
                        }
                      })}
                    </ul>
                  </div>
                )}
              </div>
              
              {/* NHL_NEW Slide Component */}
              {showSlide && slideImage && (
                sportCategory === "NHL_NEW" ? (
                  <div
                    className="nhl-slide-container"
                    style={{
                      position: "fixed",
                      top: "30%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1000,
                      "--team-color": secondaryColor,
                      // "--team-color-dark": secondaryColor,
                    }}
                  >
                  <img
                    src={slideImage}
                    alt= {`${sportCategory} Event`}
                     className="nhl-slide-image"
                     style={{
                       objectFit: "contain",
                      //  animation: "badgeAppear 4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards",
                     }}
                    
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                      const thumb = toDriveThumbUrl(slideImage);
                      if (thumb !== e.currentTarget.src) {
                        e.currentTarget.src = thumb;
                      }
                    }}
                  />
                </div>
                  ) : (
                    <div
                    className="nfl2-slide-container"
                    style={{
                      position: "fixed",
                      top: "30%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1000,
                      pointerEvents: "none",
                      "--team-color": secondaryColor,
                      // "--team-color-dark": primaryColor,
                    }}
                  >
                  <img
                    src={slideImage}
                    alt= {`${sportCategory} Event`}
                    className="nfl2-slide-image"
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                      const thumb = toDriveThumbUrl(slideImage);
                      if (thumb !== e.currentTarget.src) {
                        e.currentTarget.src = thumb;
                      }
                    }}
                  />
                </div>
                )
              )}
              
              {getReorderedDSList().map((teamArray, DS_Index) => {
                if (parseBoolean(isFree)) {
                  // Calculate the actual quarter index from the reordered list
                  const currentQuarter = selTblIdx;
                  const maxTeams = sportCategory === "MLB_NEW" ? 3 : sportCategory === "SOCCER_NEW" ? 2 : 4;
                  let actualQuarterIndex =
                    (currentQuarter - DS_Index + maxTeams) % maxTeams;
                  actualQuarterIndex = actualQuarterIndex < 0 ? maxTeams + actualQuarterIndex : actualQuarterIndex;
                  return (
                    <div key={DS_Index} className="member-msg">
                      <div
                        className={
                          actualQuarterIndex === primaryTeamIdx
                            ? "member-msg-left"
                            : "member-msg-right"
                        }
                      >
                        {}
                        <div
                          className={`member-span member-${
                            TEAM_COLOR[actualQuarterIndex]
                          }${
                            actualQuarterIndex == primaryTeamIdx
                              ? "-left"
                              : "-right"
                          }`}
                        >
                          <div
                            className={`team-span team-member-${
                              TEAM_COLOR[actualQuarterIndex]
                            }${
                              actualQuarterIndex == primaryTeamIdx
                                ? "-left"
                                : "-right"
                            }`}
                          > 
                            <span className="text-uppercase">
                              {
                                {
                                  0: player1Name.slice(0, 1),
                                  1: player2Name.slice(0, 1),
                                  2: player3Name.slice(0, 1),
                                  3: player4Name.slice(0, 1),
                                }[actualQuarterIndex]
                              }
                            </span>
                          </div>
                          {[...teamArray]
                            .reverse()
                            .sort((a, b) =>
                              a.no === "MLB-DS15-1"
                                ? -1
                                : b.no === "MLB-DS15-1"
                                ? 1
                                : 0
                            )
                            .filter((teamItem) => !teamItem.no?.includes("SCORE"))
                            .map((teamItem, teamArrayIdx) => (
                              <div
                                key={teamArrayIdx}
                                className="team-member-msg"
                              >
                                <div className="row px-4 pr-3">
                                  <div className="col-1 px-0">
                                    {(() => {
                                      let logoUrl = null;

                                      if (
                                        sportCategory === "NFL2" ||
                                        sportCategory === "NCAAFB2"
                                      ) {
                                        // For NFL2, try to determine team from description or use fallback
                                        if (
                                          teamItem.logo &&
                                          teamItem.logo > 0
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.logo - 1
                                            ].team.logo;
                                        } else if (teamItem.teamIdx !== -1) {
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.teamIdx
                                            ].team.logo;
                                        } else {
                                          // Try to determine team from description for NFL2
                                          const description =
                                            teamItem.description || "";
                                          if (
                                            description.includes("DET") ||
                                            description.includes("Lions")
                                          ) {
                                            logoUrl =
                                              playList.boxscore.teams[0].team
                                                .logo;
                                          } else if (
                                            description.includes("LAC") ||
                                            description.includes("Chargers")
                                          ) {
                                            logoUrl =
                                              playList.boxscore.teams[1].team
                                                .logo;
                                          }
                                        }
                                        if (
                                          team1Idx == 1 &&
                                          teamItem.logo == 2
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[0].team
                                              .logo;
                                        }
                                        if (
                                          team1Idx == 1 &&
                                          teamItem.logo == 1
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[1].team
                                              .logo;
                                        }
                                      } else {
                                        // For other sports, prefer explicit logo index when provided
                                        if (
                                          (sportCategory === "MLB_NEW" ||
                                            sportCategory === "NBA_NEW" ||
                                            sportCategory === "NHL_NEW" ||
                                            sportCategory === "NCAABB_NEW" ||
                                            sportCategory === "SOCCER_NEW") &&
                                          teamItem.logo &&
                                          parseInt(teamItem.logo) > 0
                                        ) {
                                          if(Number(team1Idx) === 0){
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.logo  - 1
                                            ]?.team?.logo;
                                        } else{
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.logo % 2
                                            ]?.team?.logo;
                                        }
                                      }
                                      }

                                      return teamItem.logo && logoUrl ? (
                                        <img src={logoUrl} />
                                      ) : (
                                        <></>
                                      );
                                    })()}
                                  </div>
                                  <div className="col-8">
                                    <span>{teamItem.description}</span>
                                  </div>
                                  <div className="col-1 text-end px-2">
                                    <small>
                                      {teamItem.increase == 0
                                        ? ""
                                        : teamItem.increase}
                                    </small>
                                  </div>
                                  <div className="col-1 px-4">
                                    <small>
                                      {
                                        sportCategory === "NHL_NEW"
                                          ? get_NHL_NEW_Time(teamItem.time)
                                          : teamItem.time
                                      }
                                    </small>
                                  </div>
                                  <div className="col-1"></div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  // Paid Game
                  // Calculate the actual quarter index from the reordered list
                  const currentQuarter = selTblIdx;
                  const maxTeams = sportCategory === "MLB_NEW" ? 3 : sportCategory === "SOCCER_NEW" ? 2 : 4;
                  let actualQuarterIndex =
                    (currentQuarter - DS_Index + maxTeams) % maxTeams;
                  actualQuarterIndex = actualQuarterIndex < 0 ? maxTeams + actualQuarterIndex : actualQuarterIndex;

                  return (
                    <div key={DS_Index} className="member-msg">
                      <div
                        className={
                          actualQuarterIndex == USER_POS
                            ? "member-msg-left"
                            : "member-msg-right"
                        }
                      >
                        <div
                          className={`member-span member-${
                            TEAM_COLOR[actualQuarterIndex]
                          }${
                            actualQuarterIndex == USER_POS ? "-left" : "-right"
                          }`}
                        >
                          <div
                            className={`team-span team-member-${
                              TEAM_COLOR[actualQuarterIndex]
                            }${
                              actualQuarterIndex == USER_POS
                                ? "-left"
                                : "-right"
                            }`}
                          >
                            <span className="text-uppercase">
                              {
                                {
                                  0: player1Name.slice(0, 1),
                                  1: player2Name.slice(0, 1),
                                  2: player3Name.slice(0, 1),
                                  3: player4Name.slice(0, 1),
                                }[actualQuarterIndex]
                              }
                            </span>
                          </div>
                          {[...teamArray]
                            .slice()
                            .sort((a, b) => {
                              // For MLB_NEW, reverse the order (oldest first)
                              if (sportCategory === "MLB_NEW") {
                                return a.no === "MLB-DS15-1"
                                  ? -1
                                  : b.no === "MLB-DS15-1"
                                  ? 1
                                  : 0;
                              }
                              // For NHL_NEW, data is already sorted by getReorderedDSList(), no additional sorting needed
                              if (sportCategory === "NHL_NEW") {
                                console.log(`Rendering sort: keeping order for ${a.no} vs ${b.no}`);
                                return 0; // Keep original order from getReorderedDSList()
                              }
                              // For other sports including SOCCER_NEW, show most recent first (reverse chronological)
                              return b.no.localeCompare(a.no);
                            })
                            .filter((teamItem) => !teamItem.no?.includes("SCORE"))
                            .map((teamItem, teamArrayIdx) => (
                              <div
                                key={teamArrayIdx}
                                className="team-member-msg"
                              >
                                <div className="row px-4 pr-3">
                                  <div className="col-1 px-0">
                                    {(() => {
                                      let logoUrl = null;

                                      if (
                                        sportCategory === "NFL2" ||
                                        sportCategory === "NCAAFB2"
                                      ) {
                                        // For NFL2, try to determine team from description or use fallback
                                        if (
                                          teamItem.logo &&
                                          teamItem.logo > 0
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.logo - 1
                                            ].team.logo;
                                        } else if (teamItem.teamIdx !== -1) {
                                          logoUrl =
                                            playList.boxscore.teams[
                                              teamItem.teamIdx
                                            ].team.logo;
                                        } else {
                                          // Try to determine team from description for NFL2
                                          const description =
                                            teamItem.description || "";
                                          if (
                                            description.includes("DET") ||
                                            description.includes("Lions")
                                          ) {
                                            logoUrl =
                                              playList.boxscore.teams[0].team
                                                .logo;
                                          } else if (
                                            description.includes("LAC") ||
                                            description.includes("Chargers")
                                          ) {
                                            logoUrl =
                                              playList.boxscore.teams[1].team
                                                .logo;
                                          }
                                        }
                                        if (
                                          team1Idx == 1 &&
                                          teamItem.logo == 2
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[0].team
                                              .logo;
                                        }
                                        if (
                                          team1Idx == 1 &&
                                          teamItem.logo == 1
                                        ) {
                                          logoUrl =
                                            playList.boxscore.teams[1].team
                                              .logo;
                                        }
                                      } else {
                                        // For other sports, prefer explicit logo index when provided
                                        if (
                                          (sportCategory === "MLB_NEW" ||
                                            sportCategory === "NBA_NEW" ||
                                            sportCategory === "NHL_NEW" ||
                                            sportCategory === "NCAABB_NEW" ||
                                            sportCategory === "SOCCER_NEW") &&
                                          teamItem.logo &&
                                          parseInt(teamItem.logo) > 0
                                        ) {
                                          if(Number(team1Idx) === 0){
                                            logoUrl =
                                              playList.boxscore.teams[
                                                teamItem.logo  - 1
                                              ]?.team?.logo;
                                          } else{
                                            logoUrl =
                                              playList.boxscore.teams[
                                                teamItem.logo % 2
                                              ]?.team?.logo;
                                          }
                                        }
                                      }
                                      return teamItem.logo && logoUrl ? (
                                        <img src={logoUrl} />
                                      ) : (
                                        <></>
                                      );
                                    })()}
                                  </div>
                                  <div className="col-8 px-4">
                                    <span>{teamItem.description}</span>
                                  </div>
                                  <div className="col-1 text-end px-1 pr-2" style={{ paddingRight: 16 }}>
                                    <small>
                                      {teamItem.increase == 0
                                        ? ""
                                        : teamItem.increase}
                                    </small>
                                  </div>
                                  <div className="col-1 px-2 pr-3" style={{ paddingRight: 16 }}>
                                    <small>{teamItem.time}</small>
                                  </div>
                                  <div className="col-1"></div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
            {isLoading && (
              <div
                style={{
                  position: "fixed",
                  bottom: 0,
                  right: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                  backgroundColor: "#00000090",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "100%" }}
                >
                  <div className="spinner-border  text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <CustomModal
        modalIsOpen={modalIsOpen}
        primaryColor={primaryColor}
        setModalIsOpen={setModalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        <div className="float-left text-center row mb-3">
          <div className="col">
            {teamIdxModal == 0 && (
              <input
                type="text"
                value={player1Name}
                ref={inputRef}
                onChange={(evt) => {
                  handlePlayName(evt.target.value, 1);
                }}
                className="px-2"
                style={{
                  width: 120,
                  fontWeight: "bold",
                  fontSize: 21,
                }}
              />
            )}
            {teamIdxModal == 1 && (
              <input
                type="text"
                value={player2Name}
                ref={inputRef}
                onChange={(evt) => {
                  handlePlayName(evt.target.value, 2);
                }}
                className="px-2"
                style={{
                  width: 120,
                  fontWeight: "bold",
                  fontSize: 21,
                }}
              />
            )}
            {teamIdxModal == 2 && (
              <input
                type="text"
                value={player3Name}
                ref={inputRef}
                onChange={(evt) => {
                  handlePlayName(evt.target.value, 3);
                }}
                className="px-2"
                style={{
                  width: 120,
                  fontWeight: "bold",
                  fontSize: 21,
                }}
              />
            )}
            {teamIdxModal == 3 && (
              <input
                type="text"
                value={player4Name}
                ref={inputRef}
                onChange={(evt) => {
                  handlePlayName(evt.target.value, 4);
                }}
                className="px-2"
                style={{
                  width: 120,
                  fontWeight: "bold",
                  fontSize: 21,
                }}
              />
            )}
          </div>
        </div>
        <div className="row py-3">
          <div className="col-md-12">
            <label className="form-label text-center" style={{ width: "100%" }}>
              YOUR TEAM
            </label>
            <select
              className="form-select form-select-sm"
              value={primaryTeamIdx}
              onChange={(evt) => {
                setPrimaryTeamIdx(parseInt(evt.target.value));
              }}
            >
              {(sportCategory === "MLB_NEW" ? MLB_TEAM_LIST : sportCategory === "SOCCER_NEW" ? SOCCER_TEAM_LIST : teamList).map((item, idx) => {
                const maxTeams = sportCategory === "MLB_NEW" ? 3 : sportCategory === "SOCCER_NEW" ? 2 : 4;
                return (
                  <option key={idx} value={(startPos + item) % maxTeams}>
                    {
                      {
                        0: player1Name,
                        1: player2Name,
                        2: player3Name,
                        3: player4Name,
                      }[(startPos + item) % maxTeams]
                    }
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        modalIsOpen={scoringRulesModelIsOpen}
        primaryColor={primaryColor}
        setModalIsOpen={setScoringRulesModelIsOpen}
        onRequestClose={() => setScoringRulesModelIsOpen(false)}
      >
        <div className="mb-4">
          <p className="fw-bold fs-3 text-center">RULES</p>
        </div>
        <div className="mb-3">
          <Form.Select
            onChange={(e) => {
              setSelectedSport(e.target.value);
            }}
          >
            {scoringRules.map((rule, idx) => {
              return (
                <option key={idx} value={idx}>
                  {rule.sportName}
                </option>
              );
            })}
          </Form.Select>
        </div>
        <ReactQuill
          theme="bubble"
          readOnly={true}
          value={selectedSport != -1 && scoringRules[selectedSport].rules}
        />
      </CustomModal>
      <CustomModal
        modalIsOpen={inviteModal}
        primaryColor="#000"
        setModalIsOpen={setInviteModal}
        onRequestClose={() => setInviteModal(false)}
      >
        <div className="mb-4">
          <p className="fw-bold fs-3 text-center">
            To play with a friend, copy and text this link.
          </p>
        </div>
        <CopyToClipboard
          text={`https://www.playballhog.com/playGames?sportCategory=${sportCategory}&eventId=${eventId}&team1Idx=${team1Idx}&startPos=${startPos}&primaryColor=${encodeURIComponent(
            primaryColor
          )}&secondaryColor=${encodeURIComponent(
            secondaryColor
          )}&editPrimaryTeam=${editPrimaryTeam}&isFree=${isFree}&playerNames=${playerNames}&player1Name=${player1Name}&player2Name=${player2Name}&player3Name=${player3Name}&player4Name=${player4Name}`}
          onCopy={() => {
            setCopied(true);
            setInviteModal(false);
          }}
        >
          <h5
            style={{
              color: "red",
              textAlign: "center",
            }}
          >
            Copy Link
          </h5>
        </CopyToClipboard>
      </CustomModal>
    </>
  );
}

export default PlayComponent;
